import { render, staticRenderFns } from "./trade_distribution.vue?vue&type=template&id=756cd0cc&scoped=true"
import script from "./trade_distribution.vue?vue&type=script&lang=js"
export * from "./trade_distribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756cd0cc",
  null
  
)

export default component.exports